import { IDiscoveryBox, IProduct } from '../../../model';
import { isProductDisabled } from '../../../utils';

/**
 * Gets a flag whether action proceed to checkout is enabled (e.g. all products are available)
 * @param products Products in cart
 * @param discoveryBoxes Discovery boxes in cart
 */
export const isProceedCheckoutEnabled = (products: IProduct[], discoveryBoxes: IDiscoveryBox[]): boolean =>
  !products.some((x) => isProductDisabled(x)) && !discoveryBoxes.some((x) => !x.allProductsAvailable);
